import React, { Component } from "react";
import AppModalBs from "../../partials/AppModalBs";
import AppInput from "../../partials/AppInput";

export class CareerModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: "",
      job_description: "",
      skills_required: "",
      experience_required: "",
      location: "",
      number_of_positions: 1,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.modalKey !== prevProps.modalKey) {
      this.setState({
        role: "",
        job_description: "",
        skills_required: "",
        experience_required: "",
        location: "",
        number_of_positions: 1,
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.onSubmit) {
      this.props.onSubmit(e, this.state);
    }
  };

  render() {
    let { id, title = "Add New Job", onClose, submitText = "Save", roles = [], locations = [], experience = [] } = this.props;
    const { role, job_description, skills_required, experience_required, location, number_of_positions } = this.state;

    return (
      <AppModalBs id={id} title={title} onClose={onClose} size="modal-lg">
        <form onSubmit={this.handleSubmit} key={this.props.modalKey || 'career-add-modal'}>
          <div className="px-4 py-3">
            {/* Role Field */}
            <div className="mb-3">
              <AppInput
                type="text"
                label="Role"
                name="role"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                placeholder="Please enter role"
                defaultValue={role}
                onChange={(e) => this.setState({ role: e.target.value })}
              />
            </div>

            {/* Job description Field */}
            <div className="mb-3">
              <AppInput
                type="textarea"
                label="Job description"
                name="job_description"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                placeholder="Please enter"
                rows={3}
                defaultValue={job_description}
                onChange={(e) => this.setState({ job_description: e.target.value })}
              />
            </div>

            {/* Skills Required Field */}
            <div className="mb-3">
              <AppInput
                type="textarea"
                label="Skills Required"
                name="skills_required"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                placeholder="Please enter (one per line)"
                rows={2}
                defaultValue={skills_required}
                onChange={(e) => this.setState({ skills_required: e.target.value })}
              />
            </div>

            {/* Experience Required Field */}
            <div className="mb-3">
              <AppInput
                type="textarea"
                label="Experience Required"
                name="experience_required"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                placeholder="Please enter (one per line)"
                rows={2}
                defaultValue={experience_required}
                onChange={(e) => this.setState({ experience_required: e.target.value })}
              />
            </div>

            {/* Location Field */}
            <div className="mb-3">
              <AppInput
                type="textarea"
                label="Location"
                name="location"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                placeholder="Please enter (one per line)"
                rows={2}
                defaultValue={location}
                onChange={(e) => this.setState({ location: e.target.value })}
              />
            </div>
            
            {/* Number of Positions Field */}
            <div className="mb-3">
              <AppInput
                type="number"
                label="Number of Positions"
                name="number_of_positions"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                placeholder="Please enter number of positions"
                defaultValue={number_of_positions}
                onChange={(e) => this.setState({ number_of_positions: e.target.value })}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end p-3 px-4 bg-white" style={{ borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
            <button
              type="button"
              className="btn border-0 px-4 me-3 text-secondary fw-semibold"
              data-bs-dismiss="modal"
              onClick={onClose}
              style={{ borderRadius: '8px', backgroundColor: '#e9ecef', color: '#495057' }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn text-white px-4 fw-bold"
              style={{ backgroundColor: '#ff9800', borderColor: '#ff9800', borderRadius: '8px' }}
            >
              {submitText}
            </button>
          </div>
        </form>
      </AppModalBs>
    );
  }
}

export default CareerModal;
